import Component from '../Component';
import $ from '../../vendor/CustomJquery';
import Routes from '../../routes';

export default class BlockEditor extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.elements = $('.is-block-editor');

    this.start();
    return super.initialize();
  }

  start() {
    this.elements.each((index, element) => {
      this.editor( $(element) );
    });
  }

  editor(container) {

    let value = container.text(),
        textarea = container.next('textarea');

    container.empty();

    let editor = new EditorJS({
      placeholder: 'Добавьте новый блок',
      holder: container.attr('id'),
      data: JSON.parse(value || null),
      initialBlock: 'paragraph',
      tools: {
        paragraph: {
          class: Paragraph,
          inlineToolbar: true,
        },
        header: {
          class: Header,
          inlineToolbar: true,
          config: {
            placeholder: 'Header'
          },
          shortcut: 'CMD+SHIFT+H'
        },
        list: {
          class: List,
          inlineToolbar: true,
        },
        Marker: {
          class: Marker,
          inlineToolbar: true,
          shortcut: 'CMD+SHIFT+M'
        },
        image: {
          class: ImageTool,
          inlineToolbar: true,
          config: {
            field: 'file',
            types: 'image/*',
            buttonContent: 'Загрузить',
            additionalRequestData: {
              content_type: 'dispatch',
              file_type:    'image',
              file_handler: 'image'
            },
            additionalRequestHeaders: {
              'Accept': 'application/json',
              'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content
            },
            endpoints: {
              byFile: Routes.API.STORAGE.UPLOAD,
              byUrl:  false
            }
          }
        },
        table: {
          class: Table,
          inlineToolbar: true,
          config: {
            rows: 2,
            cols: 3,
          },
        },
        code:      CodeTool,
        delimiter: Delimiter,
        button: {
          class: Button,
        },
        cities: Cities,
        promoCode: PromoCode
      },
      onReady: () => {
        //
      },
      onChange: () => {
        editor.save().then((data) => {
          this.logger('Saved data: ', data);
          textarea.val(JSON.stringify(data, null, 4));
        }).catch((error) => {
          this.logger('Saving failed: ', error);
        });
      }
    });


  }

}